import styles from './Employee.module.scss';
import LinkedinIcon from '../../assets/icons/linkedin_white.svg';

interface EmployeeProps {
    img_name: string;
    name: string;
    role: string;
    description?: string;
    linkedin?: string;
}

export const Employee = ({ img_name, name, role, description, linkedin }: EmployeeProps) => {
    const generatePathImage = (img_name: string) => {
        return `/assets/employees/${img_name}`;
    };

    return (
        <div className={styles.card}>
            <div className={styles.photo}>
                <img src={generatePathImage(img_name)} alt="Foto de perfil" />
            </div>
            <div className={styles.name}>{name}</div>
            <div className={styles.role}>{role}</div>
            {description && <div className={styles.description}>{description}</div>}
            <a href={linkedin} target="_blank" className={styles.linkedin} rel="noreferrer">
                <img src={LinkedinIcon} alt="Ícone Linkedin" />
            </a>
        </div>
    );
};
